import { useIntervalEffect } from 'src/app/hooks/useIntervalEffect';
import { checkForUnreadMessages, isChatOpenSelector, unreadChatMessageCountSelector } from 'src/app/state/slices/chat';
import { useSelector, useDispatch } from 'src/app/state/store';

export default function useUnreadChatMessages() {
  const dispatch = useDispatch();
  const isChatOpen = useSelector(isChatOpenSelector);
  const unreadMessageCount = useSelector(unreadChatMessageCountSelector);

  useIntervalEffect(
    () => {
      if (!isChatOpen) dispatch(checkForUnreadMessages());
    },
    {
      millisecondsPerInterval: 30000,
    }
  );

  return { unreadMessageCount, hasUnreadMessages: unreadMessageCount > 0 };
}
